


























































import { Component, Prop } from "vue-property-decorator";
import DataTable from "@/shared/components/data-table.vue";
import Tooltip from "@/shared/components/tooltip.vue";
import { dateTimeSeconds, dateTime, cpf } from "@/shared/filters";
import GlobalMixin from "@/shared/mixins/globalMixin";
import { mixins } from "vue-class-component";
import ComboStatus from "../promocoes/ComboStatus.vue";
import DatePicker from "@/shared/components/date-picker.vue";
import WysiwygEditor from "@/shared/components/wysiwyg-editor.vue";
import { PromocaoService, Promocao } from "@/services/promocao.service";
import { required } from "@/shared/validators";

@Component({
  components: { DataTable, Tooltip, ComboStatus, DatePicker, WysiwygEditor },
  filters: { dateTimeSeconds, cpf, dateTime },
})
export default class AlterarPromocaoForm extends mixins(GlobalMixin) {
  @Prop() idPromocao!: number;
  tipo: number | null = null;
  loading = false;
  promocao: Promise<any[]> | null = null;
  show = false;
  dadosForm: Promocao | null = null;
  urlPromocao: string | null = null;

  rules = {
    nome: [required()],
    dataInicio: [required()],
    dataFinal: [required()],
    regulamento: [required()],
  };

  mounted() {
    this.fetchUrPromocao();
    this.fetchPromocaoForm();
  }

  async fetchUrPromocao() {
    this.urlPromocao =
      (await PromocaoService.ObterUrlPromocao()) + this.idPromocao;
  }

  async fetchPromocaoForm() {
    this.loading = true;
    try {
      this.dadosForm = await PromocaoService.Manter(this.idPromocao!);
    } finally {
      this.loading = false;
    }
  }

  async salvarPromocao() {
    const form = this.$refs.form as any;

    if (form.validate()) {
      if (
        this.dadosForm!.regulamento == "" ||
        this.dadosForm!.regulamento == undefined ||
        this.dadosForm!.regulamento == null
      ) {
        this.show = true;
        setTimeout(this.fechaAlerta, 10000);
        return;
      }

      this.startLoader();
      await PromocaoService.manterPromocao(this.dadosForm!).finally(
        this.stopLoader
      );
    }
  }

  fechaAlerta() {
    this.show = false;
  }

  async acessarPromocao() {
    if (this.urlPromocao) {
      window.open(this.urlPromocao);
    }
  }
}
